/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Reference_Open_SpaceInputs */



/**
* | output |
* | --- |
* | "Open space" |
*
* @param {Project_Reference_Open_SpaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_reference_open_space = /** @type {((inputs?: Project_Reference_Open_SpaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Reference_Open_SpaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space öffnen")
	return /** @type {LocalizedString} */ ("Open space")
});